// Angular
import '@angular/platform-browser';
import '@angular/platform-browser-dynamic';
import '@angular/core';
import '@angular/common';
import '@angular/http';
import '@angular/router';
// RxJS
import 'rxjs';
// Other vendors for example jQuery, Lodash or Bootstrap
// You can import js, ts, css, sass, ...


 //import '../node_modules/zone.js/dist/zone.js';
 import '../librerias/jquery/dist/jquery.js';
 import '../librerias/jquery-bootgrid/dist/jquery.bootgrid.js';
 import '../librerias/bootstrap/dist/js/bootstrap.js';
 import 'jquery';
 import 'bootstrap';
 import '../librerias/jquery.circliful.min';
// import '../librerias/highstock';
//import '../librerias/exporting';
//import '../librerias/export-csv';
//import '../librerias/highcharts-more';
//import '../librerias/solid-gauge';


//import '../node_modules/highcharts-release/highcharts';


//import 'systemjs';


//import '../node_modules/systemjs/dist/system.src.js';
//import 'https://code.highcharts.com/stock/highstock.js';
//import 'https://code.highcharts.com/stock/modules/exporting.js';
//import '../node_modules/bootstrap/dist/js/bootstrap.js';
//import '../node_modules/bootstrap/dist/js/bootstrap.js';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/vendor.ts